import React, { useState, useEffect, useRef } from "react";
import Menu from "../Menu";
import Header from "../Header";
import "../../../App.css";
import Cookie from "js-cookie";
import LZString from "lz-string";
import { Link } from "react-router-dom";

import { Select } from "antd";
import Footer from "../Footer";
import Spinner from "../../UIComponents/Spinner/Spinner";
import AssetHealthCard from "./Cards/AssetHealthCard";
import PreventiveMaintenanceCard from "./Cards/PreventiveMaintenanceCard";
import MaintenanceIncidentCard from "./Cards/MaintenanceIncidentCard";
import ThirdPartyAuditCard from "./Cards/ThirdPartyAuditCard";
import WorkRequestCard from "./Cards/WorkRequestCard";
import {
  fetchStoreList,
  fetchTpvData,
  fetchIncidentData,
  fetchPmpData,
  fetchWorkRequestData,
} from "./actions/maintenanceDashboardService";
import { Config } from "./../../config/config";

import { useSelector, useDispatch } from "react-redux";
import {
  dashboardCityChange,
  dashboardStoreChange,
  filterOptionData,
  getCitiesForStores,
  getStoresForDashboard,
  setCurrentCity,
  setStoreId,
} from "./constant/maintenanceConstantData";
const { Option } = Select;

export default function MaintenanceDashboard() {
  const title = "";
  const [searchedItem, setSearchedItem] = useState({});
  const [showAssetHealthCard, setShowAssetHealthCard] = useState(false);
  const [showPreventiveMaintenanceCard, setShowPreventiveMaintenanceCard] =
    useState(false);
  const [showThirdPartyAuditCard, setShowThirdPartyAuditCard] = useState(false);
  const [showWorkRequestCard, setShowWorkRequestCard] = useState(false);
  const [showMaintenanceIncidents, setShowMaintenanceIncidents] =
    useState(false);
  const [cityList, setCityList] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true); //for rendering child components
  const [dashboardStoreList,setDashboardStoreList] = useState([]);
  const [storeIdsArray, setStoreIdsArray] = useState([]);
  const [intialStoreLoad, setIntialStoreLoad] = useState(false);


  const dispatch = useDispatch();
  const loading = useSelector(
    (state) => state?.maintenanceDashboardList?.loading
  );
  const TpvChartData = useSelector(
    (state) => state?.maintenanceDashboardList?.TpvChartData
  );
  const WorkRequestChartData = useSelector(
    (state) => state?.maintenanceDashboardList?.WorkRequestChartData
  );
  const PmpChartData = useSelector(
    (state) => state?.maintenanceDashboardList?.PmpChartData
  );
  const IncidentChartData = useSelector(
    (state) => state?.maintenanceDashboardList?.IncidentChartData
  );
  const dataCheck = useSelector(
    (state) => state?.maintenanceDashboardList
  );
  useEffect(()=>{
    if(TpvChartData  && WorkRequestChartData && PmpChartData && IncidentChartData ){
      setInitialLoading(false)
    }

  },[dataCheck])

  const storeList = useSelector(
    (state) => !intialStoreLoad ? dashboardStoreList : state?.maintenanceDashboardList?.StoreList || dashboardStoreList
  );

  useEffect(()=> {
    const storeString = String(storeList
      ? storeList.map(({ storeId }) => storeId).join(",")
      : "");
    setStoreIdsArray(storeString);
    const fetchDataAsync = async () => {
      await fetchData(storeString);
      setIntialStoreLoad((prevState)=> !prevState)
    };
    if (storeString.length > 0 && !intialStoreLoad) 
      fetchDataAsync();
  },[storeList]);
  const fetchData = async (storeIds) => {
    console.log("Fetching data...");
    const getChartData = async()=>{
       return await Promise.all([
        dispatch(fetchTpvData("", "", storeIds, "", "")),
        dispatch(fetchPmpData("", "", storeIds, "", "")),
        dispatch(fetchIncidentData("", "", storeIds, "", "")),
        dispatch(fetchWorkRequestData("", "", storeIds, "", "")),
      ]);
    }
    getChartData()
    

      // setInitialLoading(false);
      console.log("Data fetched, setting initialLoading to false");
  
  };
  useEffect(() => {
    const payload = {
      userId: userID,
      cityIds: "",
      appType: "Web",
    };
    dispatch(fetchStoreList(payload));

    setCityList(getCitiesForStores() || []);
    setDashboardStoreList(getStoresForDashboard() || [])
  }, []);

  useEffect(() => {
    setCurrentCity(cityList, setSearchedItem);
  }, [cityList]);

  useEffect(() => {
    setStoreId(storeList, setSearchedItem);
  }, [storeList]);
  const jsonData = Cookie.get("currentUser");
  let decompressedData = LZString.decompressFromBase64(jsonData);
  decompressedData =
    decompressedData == "\x00\x00\x00" ? jsonData : decompressedData;
  const user = JSON.parse(decompressedData);
  let userID = user["userId"];
  const config = JSON.parse(Config);
  const monthValue = config["month"];
  const years = config["years"].slice(0, 4);

  function handleSearch() {
    const store = String(searchedItem?.storeId || "") || storeIdsArray;
    const month = searchedItem?.currentMonth || "";
    const year = searchedItem?.currentYear || "";
    dispatch(fetchTpvData("", "", store, month, year));
    dispatch(fetchIncidentData("", "", store, month, year));
    dispatch(fetchPmpData("", "", store, month, year));
    dispatch(fetchWorkRequestData("", "", store, month, year));
  }

  function handleChevronRightClick(whichCard) {
    setShowAssetHealthCard(false);
    setShowPreventiveMaintenanceCard(false);
    setShowThirdPartyAuditCard(false);
    setShowWorkRequestCard(false);
    setShowMaintenanceIncidents(false);
    switch (whichCard) {
      case "asset-health":
        setShowAssetHealthCard(true);
        break;
      case "preventive-maintenance":
        setShowPreventiveMaintenanceCard(true);
        break;
      case "third-party-audit":
        setShowThirdPartyAuditCard(true);
        break;
      case "work-request":
        setShowWorkRequestCard(true);
        break;
      case "maintenance-incidents":
        setShowMaintenanceIncidents(true);
        break;
    }
  }

  const handleCityChange = (currentCity) => {
    dashboardCityChange(
      currentCity,
      cityList,
      searchedItem,
      setSearchedItem,
      dispatch,
      fetchStoreList,
      userID
    );
  };
  const handleStoreChange = (currentstores) => {
    dashboardStoreChange(
      currentstores,
      storeList,
      searchedItem,
      setSearchedItem
    );
  };

  return (
    <>
      <Header title={title} />
      <Menu />
      <div className="content-wrapper">
        {loading && initialLoading ? (
          <Spinner />
        ) : (
          <div>
            <div className="content">
              <div className="m-panel mt-10">
                <div className="m-panel__body p10">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="form-group">
                        <label htmlFor="exampleInput">Select City</label>
                        <Select
                          className="form-control"
                          placeholder="-- Please Select --"
                          mode="multiple"
                          onChange={(value) => {
                            handleCityChange(value);
                          }}
                          value={searchedItem.currentCity}
                          showSearch
                          optionFilterProp="children"
                          filterOption={filterOptionData}
                        >
                          {<Option key="selectAll">{"Select All"}</Option>}
                          {cityList &&
                            cityList.cityInfos?.map((item, index) => (
                              <Option key={item.cityId} value={item.cityId}>
                                {item.cityName}
                              </Option>
                            ))}
                        </Select>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label htmlFor="exampleInput">Select Store</label>
                        <Select
                          className="form-control"
                          placeholder="-- Please Select --"
                          mode="multiple"
                          // onChange={(value) => {
                          //   value = value.includes("selectAll")
                          //     ? (value = storeList?.map((item) => item.storeId))
                          //     : value;
                          //   value =
                          //     value.length == storeList?.length &&
                          //     searchedItem.storeId?.length == value.length
                          //       ? []
                          //       : value; // deselect all
                          //   setSearchedItem({
                          //     ...searchedItem,
                          //     storeId: value,
                          //   });
                          // }}
                          onChange={(value) => {
                            handleStoreChange(value);
                          }}
                          value={searchedItem.storeId}
                          showSearch
                          optionFilterProp="children"
                          filterOption={filterOptionData}
                        >
                          {storeList && (
                            <Option key="selectAll">{"Select All"}</Option>
                          )}
                          {storeList
                            ? storeList.map((store) => (
                                <Option
                                  key={store.storeId}
                                  value={store.storeId}
                                >
                                  {store.storeName}
                                </Option>
                              ))
                            : null}
                        </Select>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label htmlFor="exampleInput">Select Month</label>
                        <div className="">
                          <Select
                            className="form-control"
                            onChange={(value) => {
                              setSearchedItem({
                                ...searchedItem,
                                currentMonth: value,
                              });
                            }}
                            placeholder="-- Please Select --"
                            value={searchedItem.currentMonth}
                            allowClear
                          >
                            {monthValue?.map((item, index) => (
                              <Option key={index} value={index + 1}>
                                {item}
                              </Option>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label htmlFor="exampleInput">Select Year</label>
                        <Select
                          className="form-control"
                          onChange={(value) => {
                            setSearchedItem({
                              ...searchedItem,
                              currentYear: value,
                            });
                          }}
                          placeholder="-- Please Select --"
                          value={searchedItem.currentYear}
                          allowClear
                        >
                          {years?.map((item, index) => (
                            <Option key={item} value={item}>
                              {item}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </div>

                    <div className="col-md-1 btn-no-lbl">
                      <button
                        type="submit"
                        className="btn btn-secondary btn-icon deca-btn-yellow"
                        onClick={handleSearch}
                      >
                        <i className="fa fa-search"></i>
                      </button>
                    </div>
                    <div className="col-md-3 btn-no-lbl text-right">
                      <Link
                        to="/MaintenanceDashboardReport"
                        state={{ searchedItem: searchedItem }}
                      >
                        <button
                          className="deca-btn-yellow"
                          style={{
                            marginRight: "10px",
                          }}
                        >
                          Download Report
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              {initialLoading ? null : (
                <div className="chart-card-wrapper">
                  <div className="div-chart">
                    <AssetHealthCard
                      handleChevronRightClick={handleChevronRightClick}
                      setShowAssetHealthCard={setShowAssetHealthCard}
                      showAssetHealthCard={showAssetHealthCard}
                    ></AssetHealthCard>
                    <PreventiveMaintenanceCard
                      searchedItem={searchedItem}
                      handleChevronRightClick={handleChevronRightClick}
                      setShowPreventiveMaintenanceCard={
                        setShowPreventiveMaintenanceCard
                      }
                      showPreventiveMaintenanceCard={
                        showPreventiveMaintenanceCard
                      }
                    />
                  </div>
                  <div className="div-chart">
                    <ThirdPartyAuditCard
                      searchedItem={searchedItem}
                      handleChevronRightClick={handleChevronRightClick}
                      setShowThirdPartyAuditCard={setShowThirdPartyAuditCard}
                      showThirdPartyAuditCard={showThirdPartyAuditCard}
                    />
                    <MaintenanceIncidentCard
                      searchedItem={searchedItem}
                      handleChevronRightClick={handleChevronRightClick}
                      setShowMaintenanceIncidents={setShowMaintenanceIncidents}
                      showMaintenanceIncidents={showMaintenanceIncidents}
                    />
                    <WorkRequestCard
                      searchedItem={searchedItem}
                      handleChevronRightClick={handleChevronRightClick}
                      setShowWorkRequestCard={setShowWorkRequestCard}
                      showWorkRequestCard={showWorkRequestCard}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
}
